import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { trackMixpanel } from 'portal/store/mixpanel/actions'

export function useMixpanelEvents() {
  const dispatch = useDispatch()
  const { accountId, projectId } = useParams<{
    accountId: string
    projectId: string
  }>()

  return {
    trackOpen: useCallback(() => {
      dispatch(
        trackMixpanel('frontend_reports_open', {
          account_id: accountId,
          project_id: projectId,
          record_type: 'reports'
        })
      )
    }, [dispatch, accountId, projectId])
  }
}
